module.exports = __webpack_public_path__ + "img/1.6949a256.jpg";